
import React from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import { IMAGE_URL } from '../../services/api';

const ViewLeaveModal =({ show, handleClose, selectedLeave })=>{

    // const baseUrl = 'http://localhost:8000';

    return(
        <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Leave Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedLeave && (
            <Container>
              <Row className="mb-2">
                <Col><strong>ID:</strong></Col>
                <Col>{selectedLeave.employee_id || "N/A"}</Col>
              </Row>
              <Row className="mb-2">
                <Col><strong>Employee:</strong></Col>
                <Col>{selectedLeave.employee} </Col>
              </Row>
              <Row className="mb-2">
                <Col><strong>Leave Type:</strong></Col>
                <Col>{selectedLeave.leave_type}</Col>
              </Row>
              <Row className="mb-2">
                <Col><strong>Leave Dates:</strong></Col>
                <Col>{selectedLeave.leave_start_date} - {selectedLeave.leave_end_date}</Col>
              </Row>
              <Row className="mb-2">
                <Col><strong>Total Days:</strong></Col>
                <Col>{selectedLeave.total_leave_days}</Col>
              </Row>
              <Row className="mb-2">
                <Col><strong>Reason:</strong></Col>
                <Col>{selectedLeave.reason}</Col>
              </Row>
              <Row className="mb-2">
  <Col><strong>Attachments:</strong></Col>
  <Col>
    {selectedLeave.attachments && selectedLeave.attachments.length > 0 ? (
      selectedLeave.attachments.map((file, index) => (
        <div key={index}>
          <a
            href={`${IMAGE_URL}${file}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Attachment {index + 1}
          </a>
        </div>
      ))
    ) : (
      "No Attachments"
    )}
  </Col>
</Row>

            </Container>
          )}
        </Modal.Body>
      </Modal>
    );
};

export default ViewLeaveModal;